import type { TourStep } from '@/types/help-tour';
import { buildTourSteps, type TourStepDef } from '@/utils/tourI18n';

const STEP_DEFS: TourStepDef[] = [
  { target: '[data-tour="activity-intro"]' },
  { target: '[data-tour="activity-filters"]' },
  { target: '[data-tour="activity-results"]' },
  { target: '[data-tour="activity-list"]', spotlightChildCount: 3 }
];

export const FAMILY_ACTIVITY_TOUR_STEPS: TourStep[] = buildTourSteps('familyActivity', STEP_DEFS);

export const FAMILY_ACTIVITY_TOUR_STORAGE_KEY = 'wetree-family-activity-tour-completed';

export function resolveFamilyActivityTourSteps(steps: TourStep[], hasActivity: boolean): TourStep[] {
  if (hasActivity) {
    return steps;
  }
  return steps.filter((step) => step.target !== '[data-tour="activity-list"]');
}
